<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='"padding-bottom:200px;"' class="container " >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row" >
                <template #default>   </template>
                </m-div><m-h1 v-bind='{...{},...{}}' :style='"border-radius:30px"' class="text-center shadow m-4 p-4" >
                <template #default>ژل لب   </template>
                </m-h1><m-h4 v-bind='{...{},...{}}' :style='""' class="text-center m-5" >
                <template #default>فیلرهای لب نوعی پر کننده‌ی پوست هستند که با تزریق به لب، باعث فرم و حجم دادن به لب‌های شما می‌شوند. فیلرهای لب از جمله هیالورونیک اسید مصنوعی (HA)‌ تشکیل شده‌اند. HA یک ماده‌ی طبیعی است که در بدن انسان تولید می‌شود.   </template>
                </m-h4><m-section-200 v-bind='{...{"imageBefore":"https:\/\/api.arair.ir\/storage\/asset\/1.jpg","imageAfter":"https:\/\/api.arair.ir\/storage\/asset\/2.jpg","direction":"horizontal"},...{}}' :style='""' class="col-12 mx-auto text-center" >
                <template #after-1>   </template>
                
                <template #before-1>   </template>
                </m-section-200></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH1 from '@moeinmdn/miw-alpha-components/src/package/Tags/H1'; import mH4 from '@moeinmdn/miw-alpha-components/src/package/Tags/H4'; import mSection200 from '@moeinmdn/miw-alpha-components/src/package/Sections/Section200';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mH1,mH4,mSection200 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
